import {MQTT_SUBCRIBE_TOPIC, MQTT_UNSUBCRIBE_TOPIC, MQTT_CONNECTED, MQTT_OFFILNE} from '../actions/constants'

let initialState = {
  connected: false,
  topics: [],
  error: ''
}

const mqtt = (state = initialState, action) => {
  switch (action.type) {
    case MQTT_CONNECTED:
      return {
        ...state,
        connected: true
      }
    case MQTT_OFFILNE:
      return {
        ...state,
        connected: false
      }
    case MQTT_SUBCRIBE_TOPIC:
      return {
        ...state,
        topics: action.newTopicState
      }
    case MQTT_UNSUBCRIBE_TOPIC:
      return {
        ...state,
        topics: []
      }
    default:
      return state
  }
}

export default mqtt



// WEBPACK FOOTER //
// ./src/reducers/mqtt.js